import { Navigate, createBrowserRouter } from "react-router-dom";
import { LicenseInfo } from "@mui/x-license-pro";

import PageLayout from "./PageLayout";
import Dashboard from "../components/Dashboard";
import Login from "../components/Login";
import NestedPageLayout from "./NestedPageLayout";
import AuthorizedList from "../components/DataManagement/AuthorizedList";
import Blacklist from "../components/DataManagement/Blacklist";
import Maintenance from "../components/Configuration/Maintenance";
import SystemSettings from "../components/Configuration/SystemSettings";
import UserManagement from "../components/Configuration/UserManagement";
import DeviceSettings from "../components/Configuration/DeviceSettings";
import EditBuildingConfig from "../components/Configuration/SystemSettings/EditBuildingConfig";
import OTSPageLayout from "./OTSPageLayout";
import DeviceRegistration from "../components/OTS/DeviceRegistration";
import SocietyRegistration from "../components/OTS/SocietyRegistration";
import SocietyConfiguration from "../components/OTS/SocietyConfiguration";
import CamerasList from "../components/OTS/CamerasList";
import AddCamera from "../components/OTS/AddCamera";
import IntegrationSelection from "../components/OTS/IntegrationSelection";
import SetupComplete from "../components/OTS/SetupComplete";
import LiveView from "../components/LiveView";
import MyGateDeviceSetup from "../components/OTS/MyGateDeviceSetup";
import CustomFields from "../common/CustomFields";
import CustomFieldsConfig from "../components/OTS/CustomFieldsConfig";
import CameraSettings from "../components/Configuration/CameraSettings";
import NetworkSettings from "../components/NetworkSettings";

LicenseInfo.setLicenseKey(
	"8d70d9731170b6417efb13bf3e89d1f8Tz05MTc4NCxFPTE3NDkwMjEyODAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);

export const router = createBrowserRouter([
	{
		path: "/",
		element: <Navigate to="/login" replace />
	},
	{
		path: "/login",
		element: <Login />
	},
	{
		path: "/wifi",
		element: <NetworkSettings />
	},
	{
		path: "/ots",
		element: <OTSPageLayout />,
		children: [
			{
				path: "/ots",
				element: <IntegrationSelection />
				// element: <Navigate to="/ots/device-registration" replace />
			},
			{
				path: "/ots/mygate-device-setup",
				element: <MyGateDeviceSetup />
			},
			{
				path: "/ots/device-registration",
				element: <DeviceRegistration />
			},
			{
				path: "/ots/property-registration",
				element: <SocietyRegistration />
			},
			{
				path: "/ots/property-configuration",
				element: <SocietyConfiguration />
			},
			{
				path: "/ots/add-camera",
				element: <AddCamera />
			},
			{
				path: "/ots/cameras-list",
				element: <CamerasList />
			},
			{
				path: "/ots/finalize",
				element: <SetupComplete />
			},
			{
				path: "/ots/custom-fields",
				element: <CustomFieldsConfig />
			}
		]
	},
	{
		element: <PageLayout />,
		children: [
			{
				path: "/dashboard",
				element: <Dashboard />
			},
			{
				path: "/data-management",
				element: <NestedPageLayout />,
				children: [
					{
						path: "/data-management",
						element: <Navigate to="/data-management/authorized-list" replace />
					},
					{
						path: "/data-management/authorized-list",
						element: <AuthorizedList />
					},
					{
						path: "/data-management/blacklist",
						element: <Blacklist />
					}
				]
			},
			{
				path: "/configuration",
				element: <NestedPageLayout />,
				children: [
					{
						path: "/configuration",
						element: <Navigate to="/configuration/system" replace />
					},
					{
						path: "/configuration/devices",
						element: <DeviceSettings />
					},
					{
						path: "/configuration/system",
						// element: <SystemSettings />,
						children: [
							{
								path: "/configuration/system",
								element: <SystemSettings />
							},
							{
								path: "/configuration/system/building-config",
								element: <EditBuildingConfig />
							},
							{
								path: "/configuration/system/custom-fields",
								element: <CustomFields />
							}
						]
					},
					{
						path: "/configuration/additional-settings",
						element: <Maintenance />
					},
					{
						path: "/configuration/user-management",
						element: <UserManagement />
					},
					{
						path: "/configuration/camera-settings",
						element: <CameraSettings />
					},
					{
						path: "/configuration/network-settings",
						element: <NetworkSettings />
					}
				]
			},
			{
				path: "/live-view",
				element: <LiveView />
			}
		]
	}
]);
